import { MainLayoutContent } from "components/layouts/MainLayoutContent";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";

import React from 'react';
const InboxDetail = React.lazy(() => import("../page"));

const routes: AppRouteType[] = [
  {
    path: slugs.inboxDetail,
    component: InboxDetail,
    container: MainLayoutContent,
    isAuthNeeded: true,
  },
];

export default routes;
